<template>
  <span class="inline-flex items-center gap-1   rounded-full font-semibold" :class="[
    variant === 'outline' ? outlineTones[tone] : tones[tone],
    sizes[size]
  ]">
    <slot />
  </span>
</template>

<script setup lang="ts">
const tones: Record<string, string> = {
  success: 'bg-[var(--success-bg)] text-[var(--success)]',
  warning: 'bg-[var(--warning-bg)] text-[var(--warning)]',
  danger: 'bg-[var(--danger-bg)] text-[var(--danger)]',
  info: 'bg-[var(--info-bg)] text-[var(--info)]',
  neutral: 'bg-secondary text-muted-foreground',
}

const outlineTones: Record<string, string> = {
  success:
    'bg-[var(--success-bg)] text-[var(--success)] border border-[color-mix(in_srgb,var(--success)_25%,transparent)]',
  warning:
    'bg-[var(--warning-bg)] text-[var(--warning)] border border-[color-mix(in_srgb,var(--warning)_25%,transparent)]',
  danger: 'bg-[var(--danger-bg)] text-[var(--danger)] border border-[color-mix(in_srgb,var(--danger)_25%,transparent)]',
  info: 'bg-[var(--info-bg)] text-[var(--info)] border border-[color-mix(in_srgb,var(--info)_25%,transparent)]',
  neutral: 'bg-secondary text-muted-foreground border border-border/50',
}

const sizes: Record<string, string> = {
  sm: 'px-2 py-0.5 text-[11px]',
  md: 'px-2.5 py-1 text-xs',
  lg: 'px-3 py-2 text-sm',
  xl: 'px-3.5 py-3.5 text-sm',
}

const { size = 'md' } = defineProps<{
  tone?: 'success' | 'warning' | 'danger' | 'info' | 'neutral'
  variant?: 'solid' | 'outline'
  size?: 'sm' | 'md' | 'lg' | 'xl'
}>()
</script>
